import React from "react";
import "../../src/App.css";

function Roadmap() {
  return (
    <div className="page-content">
      <h1>Roadmap</h1>
      <p>
        <strong>Last Updated:</strong> May 13, 2025
      </p>
      <p>
        We’re excited to share our vision for the future of multido.com! Below
        is a roadmap of planned features and improvements. Note that timelines
        and features are subject to change based on user feedback and
        development priorities.
      </p>
      <h2>Q2 2025</h2>
      <ul>
        <li>
          <strong>Multi-Language Support:</strong> Add support for multiple
          languages to make multido.com accessible to a global audience.
        </li>
        <li>
          <strong>Task Sorting:</strong> Allow users to sort tasks by priority,
          deadline, or custom order.
        </li>
        <li>
          <strong>Accessibility Improvements:</strong> Address known
          accessibility issues, including better screen reader support for the
          date picker.
        </li>
      </ul>
      <h2>Q3 2025</h2>
      <ul>
        <li>
          <strong>Cloud Sync:</strong> Introduce optional cloud storage for
          syncing tasks across devices (opt-in with user consent).
        </li>
        <li>
          <strong>Notifications:</strong> Add reminders for upcoming deadlines
          and task completions.
        </li>
        <li>
          <strong>Collaboration Features:</strong> Allow users to share and
          collaborate on task lists with others.
        </li>
      </ul>
      <h2>Q4 2025</h2>
      <ul>
        <li>
          <strong>Mobile App:</strong> Launch native iOS and Android apps for
          multido.com.
        </li>
        <li>
          <strong>Advanced Analytics:</strong> Provide insights into
          productivity patterns based on task completion data.
        </li>
        <li>
          <strong>Custom Themes:</strong> Enable users to customize the app’s
          appearance with themes and colors.
        </li>
      </ul>
      <h2>Future Plans</h2>
      <p>
        We’re always exploring new ideas, including integrations with
        third-party apps (e.g., calendar sync), AI-driven task prioritization,
        and more. Stay tuned for updates!
      </p>
      <h2>Feedback</h2>
      <p>
        Have ideas for features you’d like to see? Let us know at{" "}
        <a href="mailto:feedback@multido.com">feedback@multido.com</a>.
      </p>
    </div>
  );
}

export default Roadmap;
